<script lang="ts">
  import { ChevronDown } from "lucide-svelte"
  import { Pulse } from "svelte-loading-spinners"
  import TopUser from "$app/Pages/Plans/Recognitions/TopUser.svelte"
  import { appStore } from "$app/store.svelte"
  import ribbonPNG from "@images/recognitions/ribbon-star.png"
  interface Props {
    currentFilterHeading?: string
    isLoadingStats?: boolean
    show_all?: boolean
    top_givers: any
  }

  let {
    currentFilterHeading = "",
    isLoadingStats = false,
    show_all = true,
    top_givers
  }: Props = $props()

  let expand_top_givers = $state(false)
</script>

<section aria-labelledby="top-senders" class="my-4">
  <div class="bg-white shadow-lg">
    <div class="pt-5 flex flex-col justify-center">
      <div
        class="flex justify-between items-center mb-2 px-6 pb-3 border-b border-gray-100"
      >
        <h2 class="text-lg font-bold text-gray-900">
          Top Givers
          <div class="text-sm">{currentFilterHeading}</div>
        </h2>
        <img src={ribbonPNG} class="h-12 w-12" alt="Top Sender" />
      </div>

      {#if isLoadingStats}
        <div class="p6 w-full">
          <div class="text-center flex justify-center">
            <Pulse size="140" color="#cdcdcd" unit="px" duration="1s" />
          </div>
        </div>
      {:else if top_givers.length > 0}
        <div class="max-h-96 overflow-y-auto">
          <div class="flow-root">
            <ul class="divide-y divide-gray-200">
              {#each top_givers.slice(0, 3) as [userId, count]}
                {@const user = appStore.users.find((u) => u.id === userId)}
                <TopUser {user} {count} />
              {/each}
              {#if expand_top_givers}
                {#each top_givers.slice(3) as [userId, count]}
                  {@const user = appStore.users.find((u) => u.id === userId)}
                  <TopUser {user} {count} />
                {/each}
                <li>
                  <button
                    onclick={() => (expand_top_givers = false)}
                    class="w-full py-2 border-t border-gray-400 hover:bg-indigo-200 px-4 text-xs text-gray-800 bg-indigo-100 flex justify-center items-center gap-1"
                  >
                    <ChevronDown class="size-6 text-gray-800 rotate-180" />
                    Show Top Three</button
                  >
                </li>
              {:else if show_all && top_givers.length > 3}
                <li>
                  <button
                    onclick={() => (expand_top_givers = true)}
                    class="w-full py-2 border-t border-gray-400 hover:bg-indigo-200 px-4 text-xs text-gray-800 bg-indigo-100 flex justify-center items-center"
                  >
                    <ChevronDown class="size-6 text-gray-800" />
                    Show All</button
                  >
                </li>
              {/if}
            </ul>
          </div>
        </div>
      {:else}
        <div class="text-lg my-6 px-4 text-center text-gray-600">
          No Recognitions in specified date period
        </div>
      {/if}
    </div>
  </div>
</section>
